import { createStore, createHook, type StoreActionApi } from '@atlassian/react-sweet-state';

export type RowCreatePosition =
	| {
			parentId?: string;
			anchorId?: string;
	  }
	| undefined;

export type RowCreateState = {
	parentId?: string;
	anchorId?: string;
};

const initialState: RowCreateState = {
	parentId: undefined,
	anchorId: undefined,
};

const actions = {
	setRowCreatePosition:
		(rowCreatePosition: RowCreatePosition) =>
		({ setState }: StoreActionApi<RowCreateState>) => {
			if (rowCreatePosition) {
				setState(rowCreatePosition);
			}
		},
	resetRowCreatePosition:
		() =>
		({ setState }: StoreActionApi<RowCreateState>) =>
			setState(initialState),
};

type Actions = typeof actions;

const ListViewRowCreateStore = createStore<RowCreateState, Actions>({
	initialState,
	actions,
	name: 'JWMListViewRowInlineCreate',
});

export const useRowCreateStore = createHook(ListViewRowCreateStore);
